import { Component, EventEmitter, Input, Output } from '@angular/core';

import { DataAccessEventsPageFacade, DataAccessFairsFacade } from '@planone/bau365/data-access-fair-data';
import { LinkClickEventType } from '@planone/bau365/feature-tracking';
import { ContactPerson, Event, Exhibitor } from '@planone/bau365/util-fair-data';
import { DataAccessTogglesFacade } from '@planone/shared/data-access-feature-flags';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'bau365-event-section-contact',
  templateUrl: './section-contact.component.html',
  styleUrls: ['./section-contact.component.scss'],
})
export class SectionContactComponent {
  @Input() exhibitor?: Exhibitor;
  @Input() event?: Event;
  @Input() exhibitorClickable = true;

  @Output() linkClicked: EventEmitter<LinkClickEventType> = new EventEmitter<LinkClickEventType>();

  hallPlanToggle$: Observable<boolean | undefined>;
  hallPlanActive$: Observable<boolean | undefined>;

  constructor(
    private EventPageFacade: DataAccessEventsPageFacade,
    public togglesFacade: DataAccessTogglesFacade,
    private fairsFacade: DataAccessFairsFacade
  ) {
    this.hallPlanToggle$ = togglesFacade.flag('kill-hall-plan');
    this.hallPlanActive$ = fairsFacade.fairConfig$.pipe(map((fair) => !!fair?.hallplan));
  }

  trackClick(element: EventTarget | null, linkType: string, linkText?: string, contactPerson?: ContactPerson) {
    if (this.event && this.exhibitor) {
      this.EventPageFacade.trackedItemClicked({
        htmlElement: element,
        linkType: linkType,
        exhibitor: this.exhibitor,
        event: this.event,
        context: this.exhibitor.fair_id,
        pageType: 'event-details',
        ...(linkText && { linkText: linkText }),
        ...(contactPerson && { contactPerson: contactPerson }),
      });

      this.linkClicked.emit({
        entityType: 'EVENT',
        linkType: linkType,
        linkText: linkText,
        context: this.exhibitor.fair_id ?? '',
        pageType: 'event-details',
        eventTarget: element ?? undefined,
      });
    }
  }
}
